import { useEffect, useState } from "react";
import { type InviteView, resolveInviteView } from "@/auth/invite-view";

/**
 * Вид страницы регистрации по токену ссылки. Без токена — сразу `form`; с
 * токеном — `checking`, пока демон не ответил. Смена токена начинает проверку
 * заново.
 */
export function useInviteView(token: string | null): InviteView {
  const [state, setState] = useState<{ token: string | null; view: InviteView }>(() => ({
    token,
    view: token === null ? "form" : "checking",
  }));

  useEffect(() => {
    if (token === null) {
      return;
    }
    let cancelled = false;
    setState({ token, view: "checking" });
    resolveInviteView(token).then((view) => {
      if (!cancelled) {
        setState({ token, view });
      }
    });
    return () => {
      cancelled = true;
    };
  }, [token]);

  // Между сменой токена и началом проверки показывать результат прошлой ссылки нельзя.
  if (state.token !== token) {
    return token === null ? "form" : "checking";
  }
  return state.view;
}
